import { render, staticRenderFns } from "./_detail_tab_receipt.vue?vue&type=template&id=85b91e40&"
import script from "./_detail_tab_receipt.vue?vue&type=script&lang=js&"
export * from "./_detail_tab_receipt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports